import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-976">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-977">
        <SparkleEffect count={80} data-id="element-978" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-979">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-980">
            Trippin' Through <span className="text-cta-500" data-id="element-981">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-982">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-983" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-984">
        <SparkleEffect count={60} data-id="element-985" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-986">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-987">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-988">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-989">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-990">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          <div id="free-lists" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16 scroll-mt-32" data-id="element-991">
            {/* NEW: Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-992">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-993">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-994">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-995">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-996">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-997">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-998" />
              </Link>
            </motion.div>

            {/* NEW: Interactive Self-Care Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-pink-50 to-white rounded-3xl p-8 border-2 border-pink-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-999">
              <div className="absolute top-4 right-4 bg-pink-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1000">
                NEW 🧖‍♀️
              </div>
              <div className="text-3xl mb-4" data-id="element-1001">🧖‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-4" data-id="element-1002">
                Free Interactive Self-Care Checklist
              </h3>
              <p className="text-pink-600 font-medium mb-8 flex-grow" data-id="element-1003">
                Daily hygiene and wellness ritual. Take care of your body and
                mind with this simple, trackable daily routine!
              </p>
              <Link to="/free-resources/self-care/daily" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 w-full" data-id="element-1004">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1005" />
              </Link>
            </motion.div>

            {/* FREE WORKOUT CONSULTATION Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-gradient-to-br from-sky-50 to-lavender-50 rounded-3xl p-8 border-2 border-sky-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1006">
              <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1007">
                FREE 💪
              </div>
              <div className="text-3xl mb-4" data-id="element-1008">💪</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1009">
                Free Workout Consultation
              </h3>
              <p className="text-plum-600 font-medium mb-3 flex-grow" data-id="element-1010">
                Meet Jake — once the smallest in the room, now lifting over 500
                lbs and training for championship-level competition. His journey
                is proof of what consistency and discipline can do.
              </p>
              <p className="text-plum-500 text-sm font-medium mb-6" data-id="element-1011">
                Free consultations, zero pressure — just real advice from
                someone who's been exactly where you are.
              </p>
              <a href="https://calendly.com/trippinwithmandy/jakes-free-workout-consultation" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-sky-500 text-white font-bold text-sm hover:bg-sky-600 transition-colors shadow-lg shadow-sky-500/20 w-full" data-id="element-1012">
                Book Free Consultation
                <ArrowRightIcon className="w-4 h-4" data-id="element-1013" />
              </a>
            </motion.div>

            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-1014">
              <div className="text-3xl mb-4" data-id="element-1015">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1016">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1017">
                <li className="flex items-start gap-2" data-id="element-1018">
                  <span className="text-cta-500 mt-1" data-id="element-1019">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-1020">
                  <span className="text-cta-500 mt-1" data-id="element-1021">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-1022">
                  <span className="text-cta-500 mt-1" data-id="element-1023">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-1024">
                  <span className="text-cta-500 mt-1" data-id="element-1025">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-1026">
                  <span className="text-cta-500 mt-1" data-id="element-1027">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-1028">
              <div className="text-3xl mb-4" data-id="element-1029">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1030">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1031">
                <li className="flex items-start gap-2" data-id="element-1032">
                  <span className="text-cta-500 mt-1" data-id="element-1033">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-1034">
                  <span className="text-cta-500 mt-1" data-id="element-1035">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-1036">
                  <span className="text-cta-500 mt-1" data-id="element-1037">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-1038">
              <div className="text-3xl mb-4" data-id="element-1039">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1040">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1041">
                <li className="flex items-start gap-2" data-id="element-1042">
                  <span className="text-cta-500 mt-1" data-id="element-1043">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-1044">
                  <span className="text-cta-500 mt-1" data-id="element-1045">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-1046">
                  <span className="text-cta-500 mt-1" data-id="element-1047">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ANXIETY GROUNDING TECHNIQUE */}
      <section className="py-8 bg-white relative overflow-hidden" data-id="element-1048">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1049">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-blush-50 to-lavender-50 rounded-3xl p-8 md:p-10 shadow-lg border border-blush-100" data-id="element-1050">
            <div className="text-center mb-6" data-id="element-1051">
              <div className="text-4xl mb-3" data-id="element-1052">🫧</div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-plum-700 mb-2" data-id="element-1053">
                Struggling with a Panic Attack?
              </h2>
              <p className="text-plum-500 font-semibold" data-id="element-1054">
                If you're having anxiety or a panic attack, try this grounding
                technique:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-1055">
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1056">
                <span className="text-3xl block mb-3" data-id="element-1057">👀</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1058">
                  See 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1059">
                  Look around and name 5 things you can see right now.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1060">
                <span className="text-3xl block mb-3" data-id="element-1061">✋</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1062">
                  Feel 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1063">
                  Touch 5 different textures — your shirt, the table, your hair.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1064">
                <span className="text-3xl block mb-3" data-id="element-1065">👂</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1066">
                  Hear 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1067">
                  Close your eyes and listen for 5 sounds around you.
                </p>
              </div>
            </div>
            <p className="text-cta-500 font-bold text-center mt-6 text-sm italic" data-id="element-1068">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </motion.div>
        </div>
      </section>

      {/* EMERGENCY CONTACTS */}
      <section className="py-16 bg-gradient-to-br from-plum-900 via-plum-800 to-plum-900 relative overflow-hidden" data-id="element-1069">
        <SparkleEffect count={40} data-id="element-1070" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-1071">
          <GlitterHeart size={48} variant="light" className="mx-auto mb-6" data-id="element-1072" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1073">
            If You're in Crisis
          </h2>
          <p className="text-white/90 text-lg mb-10 font-semibold" data-id="element-1074">
            Please don't wait. Reach out to someone who can help right now.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left mb-10" data-id="element-1075">
            <div className="bg-white/15 backdrop-blur-md rounded-2xl p-6 border border-white/30" data-id="element-1076">
              <h3 className="font-bold text-white text-xl mb-2" data-id="element-1077">
                Crisis Text Line
              </h3>
              <p className="text-white/90 mb-4 font-semibold text-base" data-id="element-1078">
                Text HOME to 741741 to connect with a crisis counselor 24/7.
              </p>
              <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-cta-300 hover:text-cta-200 font-bold transition-colors" data-id="element-1079">
                Visit Website <ArrowRightIcon className="w-4 h-4" data-id="element-1080" />
              </a>
            </div>

            <div className="bg-white/15 backdrop-blur-md rounded-2xl p-6 border border-white/30" data-id="element-1081">
              <h3 className="font-bold text-white text-xl mb-2" data-id="element-1082">
                Suicide & Crisis Lifeline
              </h3>
              <p className="text-white/90 mb-4 font-semibold text-base" data-id="element-1083">
                Call or text 988. Available 24/7, free, and confidential.
              </p>
              <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-cta-300 hover:text-cta-200 font-bold transition-colors" data-id="element-1084">
                Visit Website <ArrowRightIcon className="w-4 h-4" data-id="element-1085" />
              </a>
            </div>
          </div>

          {/* Free Coaching Call */}
          <div className="bg-gradient-to-r from-cta-500/20 to-pink-500/20 backdrop-blur-md rounded-3xl p-8 border border-cta-400/30 text-center mb-10" data-id="element-1086">
            <div className="text-4xl mb-4" data-id="element-1087">💗</div>
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-1088">
              Need Someone to Talk To?
            </h3>
            <p className="text-white/90 text-lg font-semibold mb-2 max-w-2xl mx-auto" data-id="element-1089">
              If you need someone, I'll be there. We all need someone to lean
              on.
            </p>
            <p className="text-white/70 font-medium mb-6 max-w-xl mx-auto" data-id="element-1090">
              Book a free crisis coaching call — no strings, no judgment, just
              support.
            </p>
            <a href="https://calendly.com/trippinwithmandy/crisis-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-cta-500 text-white font-bold text-lg hover:bg-cta-600 transition-all shadow-xl shadow-cta-500/30 hover:-translate-y-1" data-id="element-1091">
              Book a Free Call
              <ArrowRightIcon className="w-5 h-5" data-id="element-1092" />
            </a>
          </div>

          {/* Panic Attack Grounding */}
          <div className="bg-white/15 backdrop-blur-md rounded-3xl p-8 border border-white/30 text-left max-w-2xl mx-auto" data-id="element-1093">
            <h3 className="font-heading text-2xl font-bold text-white mb-2 text-center" data-id="element-1094">
              Struggling with a Panic Attack?
            </h3>
            <p className="text-white/80 font-semibold text-center mb-6" data-id="element-1095">
              Ground yourself during anxiety — try this right now:
            </p>
            <div className="space-y-4" data-id="element-1096">
              <div className="flex items-start gap-4" data-id="element-1097">
                <span className="text-2xl shrink-0" data-id="element-1098">👀</span>
                <div data-id="element-1099">
                  <p className="text-white font-bold text-lg" data-id="element-1100">See 5 things</p>
                  <p className="text-white/70 font-medium text-sm" data-id="element-1101">
                    Look around and name 5 things you can see right now.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-1102">
                <span className="text-2xl shrink-0" data-id="element-1103">✋</span>
                <div data-id="element-1104">
                  <p className="text-white font-bold text-lg" data-id="element-1105">
                    Feel (touch) 5 things
                  </p>
                  <p className="text-white/70 font-medium text-sm" data-id="element-1106">
                    Touch 5 different textures — your shirt, the table, your
                    hair.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-1107">
                <span className="text-2xl shrink-0" data-id="element-1108">👂</span>
                <div data-id="element-1109">
                  <p className="text-white font-bold text-lg" data-id="element-1110">Hear 5 things</p>
                  <p className="text-white/70 font-medium text-sm" data-id="element-1111">
                    Close your eyes and listen for 5 sounds around you.
                  </p>
                </div>
              </div>
            </div>
            <p className="text-cta-300 font-bold text-center mt-6 text-sm italic" data-id="element-1112">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </div>
        </div>
      </section>
    </div>;
}